// Re-exports the integration scope resolver as a project-registered
// function so any page can pick it up via `el.call('resolveScope', ...)`
// without a file import.
//
// Reads { scopeType, scopeId } off an integration draft state, supplying
// defaults. Used by every integration configure form (governance admin
// pages + marketplace install flow) so scope handling stays centralized.
export { resolveScope } from '../components/IntegrationScopePicker.js'
